import { gridSize, gridSizeMdLg4, TipoProductoEnumChoice, useTableFilter, useTableServerSideFiltering } from "@/shared"
import { getUbicacionProductos, useFetchCategoryProduct, useFetchProductos } from "@/shared/actions/erp"
import { CustomAutocomplete, GeneralTable, TabTextLabel } from "@/shared/components/ui"
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs"
import { AlertSeverityEnum, IDataProducto } from "@/shared/interfaces"
import { MaterialesKey, useMaterialesUtilizadosStore } from "@/store/erp"
import { useUiStore } from "@/store/ui"
import { Grid, Paper } from "@mui/material"
import { MRT_ColumnDef } from "material-react-table"
import React, { useEffect, useMemo, useState } from "react"
import { useForm } from "react-hook-form"

export interface ProductoPedidosIngresoDynamicTableProps {
  open: boolean,
  setOpen: (open: boolean) => void
  ubicacion: string;

}
const ProductoPedidosIngresoDynamicTable: React.FC<ProductoPedidosIngresoDynamicTableProps> = ({ open, setOpen, ubicacion }) => {
  ////* global state
  const addProductoSinSeriesItem = useMaterialesUtilizadosStore(
    (s) => s.addSolicitudesComprasProducto
  );
  const [selectGrupo, setSelectedGrupo] = useState(false)
  const [selectTipoProducto, setSelectTipoProducto] = useState<string>('')
  const [selectCategoria, setSelectCategoria] = useState<string>('')

  /* const tipoProductoEnum = Object.entries(TipoProductoEnumChoice).map(
    ([key, value]) => ({ label: key, value })
  ); */
  const tipoProductoEnum = Object.entries(TipoProductoEnumChoice)
    .filter(([value]) => value === TipoProductoEnumChoice.INVENTARIABLE || value === TipoProductoEnumChoice.ACTIVOS)
    .map(([key, value]) => ({ label: key, value }));

  const setAlert = useUiStore((s) => s.setAlert);

  const form = useForm();

  const { control } = form;
  ///table
  const { pagination,setPagination,searchTerm,} = useTableFilter();

  const { pageIndex, pageSize } = pagination;
  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering()

  const { data: CategoriaProductosPaging, isLoading: isLoadingCategoriaProductos } =
    useFetchCategoryProduct({
      page_size: 600,
    });

  const { data: dataProductos, isLoading: isLoadingProducto, isRefetching: isRefetchingProducto } = useFetchProductos({
    page: pageIndex + 1,
    page_size: pageSize,
    categoria_producto: selectCategoria,
    tipo_producto: selectTipoProducto,
    codigo: searchTerm,
    ...filterObject,
    filterByState: false
  })

  const onChangeGrupoCatalogo = (value: string) => {
    setSelectedGrupo(true)
    setSelectTipoProducto(value)
  }
  const onChangeCategoriaProducto = (value: string) => {
    setSelectCategoria(value)
  }
  ///barrido para capturar el codigo de stock actual
  const ubiProductoStock = async (codigo: string) => {
    const resp = await getUbicacionProductos({
      page_size: 600,
      productos: codigo,
      ubicacion: ubicacion
    });
    if (resp && resp.data.data.length > 0) {
      return resp.data.data[0].stock
    } else {
      return 0;
    }

  }
  const onChange = async (item: IDataProducto) => {
    const stockActual = await ubiProductoStock(item.codigo)
    addProductoSinSeriesItem({
      ...item,
      cantidad: "0",
      stock_actual: stockActual,
      id: item.id_producto
    }, MaterialesKey.solicitudCompras)

  }
  const columnsProductosPedidosDb: MRT_ColumnDef<IDataProducto>[] = useMemo<MRT_ColumnDef<IDataProducto>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'codigo'
      },
      {
        accessorKey: 'codigo',
        header: 'codigo'
      }, {
        accessorKey: 'descripcion',
        header: 'descripcion'
      },
      {
        accessorKey: 'marca_producto',
        header: 'marca'
      },
      {
        accessorKey: 'modelo_producto',
        header: 'modelo'
      },
      {
        accessorKey: 'categoria_producto',
        header: 'categoria'
      },
      {
        accessorKey: 'unidad_medida',
        header: 'Medida'
      }
    ],
    [addProductoSinSeriesItem] // Agrega aquí la lista de dependencias
  );
  useEffect(() => {
    if (!isLoadingProducto && dataProductos?.data.count === 0) {
      setAlert(true, "! No se encontraron productos. !", AlertSeverityEnum.info)
    }
  }, [dataProductos])

  return (
    <ScrollableDialogProps
      open={open}
      title="Productos"
      onCloseIcon={() => setOpen(false)}
      minWidth="75%"
      contentNode={
        <>
          <Grid item {...gridSize}>
            <Paper className="paper-producto">
              <Grid container spacing={1} alignItems={"center"}>

                <Grid item {...gridSizeMdLg4}>

                  <CustomAutocomplete
                    label="Grupo Catalogo"
                    name="tipo_producto"
                    options={tipoProductoEnum || []}
                    isLoadingData={false}
                    error={undefined}
                    defaultValue={form.getValues().tipo_producto || ''}
                    control={form.control}
                    valueKey={"value"}
                    helperText={undefined}
                    onChangeValue={(e) => {
                      onChangeGrupoCatalogo(e)
                      /* if(!e) return ({tipo_producto:'', categoria_producto:''}) */
                      form.reset({ ...form.getValues(), categoria_producto: '' })
                    }}
                  />
                </Grid>
                {selectGrupo && form.getValues().tipo_producto && (
                  <Grid item {...gridSizeMdLg4}>
                    <CustomAutocomplete
                      label="Categoria del producto"
                      name="categoria_producto"
                      options={CategoriaProductosPaging?.data.data || []}
                      valueKey="nombre"
                      defaultValue={''}
                      isLoadingData={isLoadingCategoriaProductos}
                      control={control}
                      error={undefined}
                      helperText={undefined}
                      onChangeValue={onChangeCategoriaProducto}
                    />
                  </Grid>
                )}

              </Grid>
              <Grid item>
                <TabTextLabel text="Agregar Productos" mt={0} pb={0} pl={0} pt={0}></TabTextLabel>
              </Grid>
              <div className="linea"></div>
              <Grid item xs={12}>
                {!selectGrupo && !form.getValues().tipo_producto && (
                  <Grid item>
                    <TabTextLabel
                      text={"Seleccione la opción Grupo Catálogo para cargar el producto"}
                      mt={0}
                      pb={1}
                      pl={0}
                      pt={1}
                    />
                  </Grid>

                )}
                {
                  selectGrupo && form.getValues().tipo_producto && (
                    <GeneralTable
                      columns={columnsProductosPedidosDb}
                      data={dataProductos?.data.data || []}
                      isLoading={isLoadingProducto}
                      isRefetching={isRefetchingProducto}
                      enableGlobalFilter={false}
                      //
                      pagination={pagination}
                      onPaging={setPagination}
                      rowCount={dataProductos?.data.count}
                      //
                      columnFilters={columnFilters}
                      onColumnFiltersChange={setColumnFilters}
                      enableManualFiltering={true}
                      enableSorting={false}
                      //
                      canEdit={false}
                      enableColumnActions={true}
                      canAdd={true}
                      onAdd={e => { onChange(e) }}
                    />

                  )
                }


              </Grid>
            </Paper>

          </Grid>
        </>
      }
    />

  )
}
export default ProductoPedidosIngresoDynamicTable;